import { defaultLayers } from "./default";
import DefaultLayers from "./Layers";

export default { DefaultLayers, defaultLayers };
